// Host-based separation between the public website and the portal.
//
// - The portal (admin + customer login) is served on a "portal." subdomain,
//   e.g. https://portal.voip2.co.uk (same build, different hostname).
// - REACT_APP_PORTAL_URL (e.g. https://portal.voip2.co.uk) makes the main
//   site link and redirect portal paths to that subdomain. When it is unset
//   (local dev / single-domain deploys) everything stays on one origin.

export const isPortalHost = () =>
  window.location.hostname.startsWith('portal.');

const configuredPortalBase = (process.env.REACT_APP_PORTAL_URL || '').replace(/\/+$/, '');

// True when portal paths must be redirected off the main site.
export const shouldRedirectToPortal = () =>
  Boolean(configuredPortalBase) && !isPortalHost();

// Absolute (or same-origin) URL for a portal path such as /customer/login.
export const portalUrl = (path = '/customer/login') => {
  if (configuredPortalBase && !isPortalHost()) {
    return `${configuredPortalBase}${path}`;
  }
  return path;
};
